<template>
    <v-dialog v-model="editorShownSicknessChangeStatus" width="850">
        <v-card style="border: 2px solid grey;">
            <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px; color: grey;" class="b-fa b-fa-briefcase-medical"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }}  - Multiple (CHANGE STATUS)
            </v-card-title>

            <v-card-text class="pa-5">

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="certificate" label="Select - CERTIFICATE:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="fit" label="Select - FIT:" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickOnTour" label="Select - SICKONTOUR:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickChild" label="Select - SICKCHILD:" />
                    </v-col>
                </v-row>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownSicknessChangeStatus = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_SicknessUpdateMultipleStatus"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import YesnoCombo from '../../YesnoCombo.vue';

    import { mapGetters, mapActions } from 'vuex';


    export default {
        name  : 'event-editor-sickness-change-status',

        /* >>> *************************************************************** / /* Props */
        props : {

            value       : [ Boolean, Object ],// editorShownSicknessChangeStatus
            eventRecord : Object,
            eventStore  : Object,
            resourceId  : [ String, Number ],

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            YesnoCombo,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            eventName       : '',
            // >>> ------------------------------
            certificate     : null,
            fit             : null,
            sickOnTour      : null,
            sickChild       : null,
            // >>> ------------------------------

        }), // eo fucntion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_selectedMultiEventsEntireRecord', // get: selected Events (entire records)
            ]),


            /*******************************************************************
            * editorShownSicknessChangeStatus()
            *
            * Desc:
            * Note:
            *
            */
            editorShownSicknessChangeStatus: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                *
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        eventRecord = me.eventRecord;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/sickness/EventEditorChangeStatus.vue >>> editorShownSicknessChangeStatus get');
                    if (true === me.value) {                                    // we're opening so initialize data
                        if (eventRecord) {
                            Object.assign(me, {
                                eventName       : eventRecord.name,
                                certificate     : false,
                                fit             : false,
                                sickOnTour      : false,
                                sickChild       : false,
                            });
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo function editorShownSicknessChangeStatus get()

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/sickness/EventEditorChangeStatus.vue >>> editorShownSicknessChangeStatus set');
                    this.$emit('input', value);

                } // eo function editorShownSicknessChangeStatus set()

            } // eo editorShownSicknessChangeStatus

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_changestatus_Multiple_Sicknesses', // Call: Change Status Multiple Sicknesses
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_SicknessUpdateMultipleStatus()
            *
            * Desc:
            * Note: Getting marked Events right here!
            *
            */
            onSave_SicknessUpdateMultipleStatus: function() {

                let me = this,
                    markedEvents = this.get_selectedMultiEventsEntireRecord,
                    idIllnesses = [],
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditorChangeStatus.vue >>> onSave_SicknessUpdateMultipleStatus');
                if (markedEvents.length > 0) {
                    markedEvents.forEach(event => {
                        if (event.data.name !== 'FLIGHT' && event.data.name !== 'CHECKIN' && event.data.name !== 'CHECKOUT') {
                            if (event.data.name === 'SICKNESS') {
                                idIllnesses.push(event.data.originalId);
                                // myParams.recs.push(event);
                            }
                        }
                    });
                }

                params = {
                    certificate     : me.certificate,
                    fit             : me.fit,
                    sickOnTour      : me.sickOnTour,
                    sickChild       : me.sickChild,
                    idIllnesses     : idIllnesses
                };


                this.actn_changestatus_Multiple_Sicknesses(params);

            }, // eo function onSave_SicknessUpdateMultipleStatus()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
